import { render, staticRenderFns } from "./ShowDamagedCharactersCheckbox.vue?vue&type=template&id=70fcdf77&"
import script from "./ShowDamagedCharactersCheckbox.vue?vue&type=script&lang=js&"
export * from "./ShowDamagedCharactersCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports